<template>
	<div  v-on:click="fullscreen" v-if="!hidden" class="clickFullscreenOverlay">
		<div class="iconContainer">
			<p> {{ $t('clickFullscreen') }} <i class="fa fa-expand"></i> </p>
		</div>
	</div>
</template>

<script>

export default {

  data: function(){ 
    return{
    	hidden: true,
    	screenfull: false,
    }
  },

  methods: {

  	fullscreen(){
  		this.screenfull.request();
  		this.hidden = true;
  	}

  },

  mounted(){


  	var self = this;

  	/*------------------------------------------	*
      Screenfull
    --------------------------------------------*/
    var platform = require('platform');
    var screenfull = require('screenfull')
    this.screenfull = screenfull;

    if (screenfull.enabled && self.device.isMobile) {
      
    	  self.hidden = false;

        self.screenfull.on("change", function(event){
        	
        	if(self.screenfull.isFullscreen){
        		// Fullscreen has been turned on
        	}
        	else
        	{
        		self.hidden = false;
        	}

        })

     }

  }

}
</script>

<style>

	.clickFullscreenOverlay{
		position:fixed;
		top:0;
		bottom: 0;
		background-color: rgba(0, 0, 0, 0.7);
		width:100%;
		height:100%;
		color: white;
		z-index: 999998;

		.iconContainer{
			position: absolute;
			text-align: center;
		    width: 100%;
		    top: 50%;
		    margin-top: -27px;
		    font-size: 21px;

		    i{
		    	margin-left: 10px;
		    }
		}
	}


</style>



// WEBPACK FOOTER //
// ClickFullscreen.vue?7f52066d